<template>
	<div class="map_box">
		<div class="img_map">
			<img width="837" height="580" src="../../../assets/map/3141.png" alt="">
		</div>
		<div class="map_box_ceng_left">
			<div class="ceng">
				<div class="ceng_boxD6 scale"></div>
				<div class="ceng_boxD4 scale"></div>
				<div class="ceng_boxD2 scale"></div>
			</div>
			<div class="ceng">
				<div class="ceng_boxS5 scale"></div>
				<div class="ceng_boxS3 scale"></div>
				<div class="ceng_boxS1 scale"></div>
			</div>

		</div>
		<div class="map_box_ceng_right">
			<div class="map_box_ceng_right_top">
				<div class="ceng_top">
					<div class="ceng_boxT11 scale"></div>
					<div class="ceng_boxT16 scale"></div>
				</div>
				<div class="ceng_top">
					<div class="ceng_boxT10 scale"></div>
					<div class="ceng_boxT15 scale" @click="showW2d"></div>
				</div>
				<div class="ceng_top">
					<div class="ceng_boxT9 scale"></div>
					<div class="ceng_boxT14 scale"></div>
				</div>
			</div>
			<div class="map_box_ceng_right_buttom">
				<div class="ceng_buttom">
					<div class="ceng_boxB8 scale"></div>
					<div class="ceng_boxB13 scale"></div>
					<div class="ceng_boxB18 scale"></div>
				</div>
				<div class="ceng_buttom">
					<div class="ceng_boxB7 scale"></div>
					<div class="ceng_boxB12 scale"></div>
					<div class="ceng_boxB17 scale"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
			siteId: '',
			siteType: '',
			}
		},
		methods: {
			showW2d: function() {
				let body={
					siteId:'19',
					siteType: '03',
					nameflase:false
				}
				this.$emit('getSiteId', body)
			}
		},
	}
</script>

<style>
	.map_box {
		width: 52.9375rem;
		height: 36.25rem;
		/* background-color: red; */
		/* 		background-image: url('../../../assets/map/组 2012394.png'); */
		z-index: 999;
		position: absolute;
		left: 23.4375rem;
		top: 0;
		padding-left: 0.3125rem;
		padding-right: 0.3125rem;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.map_box .img_map {
		width: 52.3125rem;
		height: 36.25rem;
		position: absolute;
		top: 0;
		left: 5px;
		z-index: 999;
	}

	.map_box_ceng_right {
		width: 16.75rem;
		height: 22.875rem;
		z-index: 999;
		margin-left: 3.125rem;
	}

	.map_box_ceng_right .map_box_ceng_right_top {
		width: 10.75rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.map_box_ceng_right .map_box_ceng_right_buttom {
		width: 16.75rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.ceng_top {
		width: 10.75rem;
		height: 4.375rem;
		z-index: 999;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

	}

	.map_box_ceng_left {
		width: 18.75rem;
		height: 11.875rem;
		z-index: 999;
		margin-left: 0.625rem;
		margin-top: 1.875rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.ceng_buttom {
		width: 16.75rem;
		height: 4.375rem;
		z-index: 999;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

	}

	.ceng {
		width: 18.75rem;
		height: 4.375rem;
		z-index: 999;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

	}

	/* 层图 */

	/* 双数 */
	.ceng_boxD4 {
		width: 5.5rem;
		height: 4.375rem;
		/* 	background-color: gold; */
		z-index: 999;
		background-image: url(../../../assets/map/map4.png);
	}

	.ceng_boxD2 {
		width: 5.5rem;
		height: 4.375rem;
		/* 	background-color: gold; */
		z-index: 999;
		background-image: url(../../../assets/map/map2.png);
	}

	.ceng_boxD6 {
		width: 5.5rem;
		height: 4.375rem;
		/* 	background-color: gold; */
		z-index: 999;
		background-image: url(../../../assets/map/map6.png);
	}

	/* 单数 */
	.ceng_boxS5 {
		width: 5.5rem;
		height: 4.375rem;
		/* 	background-color: gold; */
		z-index: 999;
		background-image: url(../../../assets/map/map5.png);
	}

	.ceng_boxS3 {
		width: 5.5rem;
		height: 4.375rem;
		/* 	background-color: gold; */
		z-index: 999;
		background-image: url(../../../assets/map/map3.png);
	}

	.ceng_boxS1 {
		width: 5.5rem;
		height: 4.375rem;
		/* 	background-color: gold; */
		z-index: 999;
		background-image: url(../../../assets/map/map1.png);
	}

	.ceng_box {
		width: 4.75rem;
		height: 3.375rem;
		background-color: gold;
		z-index: 999;
		background-image: url(../../../assets/map/map1.png);
	}

	/* 右图层 */

	.ceng_boxT11 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map11.png);
	}

	.ceng_boxB12 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map12.png);
	}

	.ceng_boxT10 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map10.png);
	}

	.ceng_boxT16 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map16.png);
	}

	.ceng_boxT9 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map9.png);
	}

	.ceng_boxT15 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map15.png);
	}

	.ceng_boxB8 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map8.png);
	}

	.ceng_boxT14 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map14.png);
	}

	.ceng_boxB18 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map18.png);
	}

	.ceng_boxB7 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map7.png);
	}

	.ceng_boxB13 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map13.png);
	}

	.ceng_boxB17 {
		width: 4.75rem;
		height: 3.375rem;
		z-index: 999;
		background-image: url(../../../assets/map/map17.png);
	}

	.scale:hover {
		-webkit-transform: scale(1.08, 1.08);
		transform: scale(1.08, 1.08);
	}
</style>



// WEBPACK FOOTER //
// src/page/maintain/main/w2dDitu.vue